import Link from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import Group from "@midland-industries/Components/Group";
import Stack from "@midland-industries/Components/Stack";
import { colors } from "@midland-industries/Styles/colors";
import { SlideFields } from "@midland-industries/Widgets/Basic/Slider";
import parse from "html-react-parser";
import React from "react";

const RightAlignedSlide: React.FC<SlideFields> = ({
    eyebrowText,
    headingText,
    contentText,
    callToActionLabel,
    callToActionLink,
    lightText,
}) => {
    return (
        <Group justify="flex-end" style={{ height: 254, width: 1112, margin: "0 auto" }}>
            <Stack gap={9} style={{ width: 460 }} justify="center" align="center">
                {eyebrowText ? (
                    <Typography
                        style={{ textAlign: "center" }}
                        transform="uppercase"
                        lineHeight="24px"
                        color={lightText ? colors.background : colors.textAccent}
                    >
                        {parse(eyebrowText)}
                    </Typography>
                ) : (
                    <></>
                )}
                {headingText ? (
                    <Typography
                        style={{ textAlign: "center", letterSpacing: "-0.336px" }}
                        weight={700}
                        lineHeight="38px"
                        size={32}
                        color={lightText ? colors.background : colors.textMain}
                    >
                        {parse(headingText)}
                    </Typography>
                ) : (
                    <></>
                )}
                {contentText ? (
                    <Typography
                        style={{ textAlign: "center", letterSpacing: "-0.176px" }}
                        lineHeight="24px"
                        color={lightText ? colors.background : colors.textAccent}
                    >
                        {parse(contentText)}
                    </Typography>
                ) : (
                    <></>
                )}
                {callToActionLabel ? <Link href={callToActionLink.value}>{parse(callToActionLabel)}</Link> : <></>}
            </Stack>
        </Group>
    );
};

export default RightAlignedSlide;
